import { Navigate } from 'react-router-dom';
import LegacyCurrentAlerts from "./LegacyCurrentAlerts";
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router"
import CurrentAlerts from "./CurrentAlerts";
import CurrentCloudAlerts from "./CurrentCloudAlerts";
import SessionReload from "./component-assets/SessionReload";
import {compareRole, iAmHigherAuthority} from "../libs";
import CurrentAlertsV2 from "./CurrentAlertsV2";

const Alerts = (props) => {
    let alertContent, dData, paramVars, bData;
    paramVars = useParams()

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (dData.migrated){
        alertContent = <CurrentAlertsV2 />;
    }else{
        if (paramVars.dType === "all"){
            alertContent = <LegacyCurrentAlerts toFetch={"all"}/>;
        }
        else if (paramVars.dType === "emergency"){
            alertContent = <LegacyCurrentAlerts toFetch={"emergency"}/>;
        }
        else if (paramVars.dType === "maintenance"){
            alertContent = <LegacyCurrentAlerts toFetch={"maintenance"}/>;
        }
        else if (paramVars.dType === "system"){
            alertContent = <LegacyCurrentAlerts toFetch={"system"}/>;
        }
        else{
            alertContent = (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }

    return (compareRole("", dData?.userrole) || iAmHigherAuthority(0, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {alertContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Alerts;